import { docPlainText } from "./doc-content";
import { FRAME_CONTENT_PADDING } from "@/components/shapes/shared/frame-content-padding";
import { cn } from "@/lib/cn";

/** Longest plain-text excerpt the fallback shows. */
const FALLBACK_MAX_CHARS = 4000;

interface DocReadOnlyFallbackProps {
  frameType: string;
  content: Record<string, unknown> | undefined;
}

/**
 * Read-only plain text of a Doc whose content failed to convert to blocks.
 * It has no editing surface, so nothing can be saved over the stored content.
 */
export function DocReadOnlyFallback({
  frameType,
  content,
}: DocReadOnlyFallbackProps) {
  const text = docPlainText(frameType, content);
  const excerpt =
    text.length > FALLBACK_MAX_CHARS
      ? `${text.slice(0, FALLBACK_MAX_CHARS - 1).trimEnd()}…`
      : text;
  return (
    <div
      className={cn(
        "scrollbar-none nodrag min-h-0 flex-1 overflow-y-auto whitespace-pre-wrap text-appkit-body text-primary",
        FRAME_CONTENT_PADDING,
      )}
      data-frame-content="true"
      data-testid="doc-readonly-fallback"
    >
      {excerpt}
    </div>
  );
}
